@import '../../theme/colors';

.root {
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

.breadcrumb a,
.breadcrumb h1 {
  font-size: 20px !important;
  @media (max-width: 640px) {
    font-size: 16px !important;
  }
}

.error {
  margin-top: 20px;
  margin-bottom: -20px;
}

.detailsSectionContent {
  padding: 16px 0;
  margin: 0;
  display: flex;
  justify-content: space-between;
  > div {
    padding: 0 30px;
  }
  dt {
    white-space: nowrap;
  }
  @media (max-width: 640px) {
    flex-direction: column;
    & > div {
      margin-bottom: 8px;
      padding-bottom: 0;
    }
  }
}

.descriptionField {
  flex: 1;
}

.buildSection {
  margin-top: 20px;
  flex: 1;
}

.detailListItem {
  dt {
    color: #4f4f4f;
    font-family: var(--font-family__heading);
    font-size: 11px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 16px;
  }
  dd {
    margin: 0;
    font-family: var(--font-family__body);
    font-size: 14px;
    font-weight: 300;
  }
}

.tableWrapper {
  overflow-x: auto;
}

.attributeRow {
  list-style: none;
  margin: 0;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid $neutral-300;
  font-size: 14px;
  font-weight: 400;
  padding: 10px;
  padding-left: 6px;

  li {
    padding: 10px;
  }

  .baseOperator {
    flex: 0 0 105px;
    text-align: right;
  }

  .attribute {
    margin: 0;
    padding: 0;
    list-style: none;
    flex: 1 0 600px;
    display: flex;
  }

  .customers {
    font-weight: 600;
    white-space: nowrap;
    display: flex;
    align-items: flex-end;
    align-items: center;
  }

  .attributeGroup {
    margin: 0;
    padding: 0;
    list-style: none;
    flex: 1 0 600px;
    &.deeplyNested {
      padding-left: 10px;
      border-left: 2px solid $neutral-300;
      position: relative;
      &::before {
        content: '';
        position: absolute;
        width: 8px;
        height: 2px;
        background-color: $neutral-300;
        left: -1px;
        top: 0;
      }
      &::after {
        content: '';
        position: absolute;
        width: 8px;
        height: 2px;
        background-color: $neutral-300;
        left: -1px;
        bottom: 0;
      }
    }
  }

  .attributeName {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display: flex;
    align-items: center;
  }

  .filterText {
    flex: 1 0 1;
  }

  .operator {
    font-weight: 600;
    text-transform: uppercase;
  }

  .filterOperator {
    flex: 0 0 100px;
    width: 100%;
    text-align: center;
  }
  .inlineOperator {
    margin-right: 8px;
  }
  .blankOption {
    font-style: italic;
  }

  .transactionalRow {
    display: flex;
    flex-wrap: wrap;
  }

  .transactionalFilterName {
    padding-right: 10px;
  }
  
  .transactionalAttributeContainer {
    display: flex;
    align-items: center;
  }
  
  .transActionalSegmentalOperator {
    font-weight: '600';
  }

  .transactionalOperator {
    font-weight: 600;
    text-transform: uppercase;
    padding-right: 10px;
  }
}
